import type { GuildData, Me } from './api.js';

/** Глобальное состояние приложения. */
export const app = {
  me: null as Me | null,
  guild: null as GuildData | null,
  /** тема предпросмотра */
  previewTheme: 'dark' as 'dark' | 'light',
  previewMobile: false,
};

export function roleById(id: string) {
  return app.guild?.roles.find((r) => r.id === id);
}

export function channelById(id: string) {
  return app.guild?.channels.find((c) => c.id === id) ?? app.guild?.threads.find((t) => t.id === id);
}

export function templateById(id: string) {
  return app.guild?.templates.find((t) => t.id === id);
}
